import {getPeriodActsGenerate} from "@/api/periodActsGenerate";

const state = {
    list: []
}

const mutations = {
    SET_PERIOD_ACT_GENERATE: (state, payload) => {
        state.list = payload
    }
}

const actions = {
    getPeriodActsGenerate({ commit }) {
        getPeriodActsGenerate().then(response => {
            commit('SET_PERIOD_ACT_GENERATE', response.data)
        })
    }
}

export default {
    state,
    // getters
    mutations,
    actions,
};
